import { createContext } from 'react'
import { Routing } from 'helpers/routing'

const TournamentContext = createContext<{
    params?: Routing.TournamentParams
}>({})

export { TournamentContext }